import React, { useState } from "react";
import { Card } from "reactstrap";

import { BlockBetween } from "../../Component";
import BlockUpdateButton from "../../button/BlockUpdateButton";
import MultiLanguageInput from "../MultiLanguageInput";
import MultiLanguageListInput from "../MultiLanguageListInput";
import { RichMultiLanguageView, RichListItemsView } from "./RichTextView";
import { useVacancyBlockSave } from "./useVacancyBlockSave";

import { normalizeVacancy } from "../../../utilities/vacancyUtils";

// Bitta maydon — o'z "Update Block" tugmasi bilan. Saqlaganda faqat shu
// maydon yuboriladi, qolgani serverdagi holicha qoladi.
const VacancyFieldBlock = ({
  label,
  isList = false,
  addButtonTitle,
  getInitial,
  getSaved,
  buildPatch,
}) => {
  const { save, vacancy } = useVacancyBlockSave();

  const [hasEditClicked, setHasEditClicked] = useState(false);
  const [value, setValue] = useState(() => getInitial(normalizeVacancy(vacancy)));

  const handleOnEditClicked = () => setHasEditClicked((prev) => !prev);

  const handleSubmit = (e) => {
    e.preventDefault();
    save(buildPatch(value, normalizeVacancy(vacancy)), () =>
      setHasEditClicked(false)
    );
  };

  const savedValue = getSaved(vacancy);

  return (
    <Card className="card-bordered card-inner mb-3">
      <form onSubmit={handleSubmit}>
        <BlockBetween className="align-items-center mb-2">
          <div className="d-flex align-items-center">
            <label className="form-label mb-0">{label}</label>
            {isList && (
              <span className="badge badge-dim badge-light ml-2">
                {(hasEditClicked ? value : savedValue)?.length ?? 0}
              </span>
            )}
          </div>
          <BlockUpdateButton
            hasEditClicked={hasEditClicked}
            handleOnEditClicked={handleOnEditClicked}
            className="m-0"
          />
        </BlockBetween>

        {hasEditClicked ? (
          isList ? (
            <MultiLanguageListInput
              items={value}
              onChange={setValue}
              addButtonTitle={addButtonTitle}
              bare
            />
          ) : (
            <MultiLanguageInput value={value} onChange={setValue} isRichText bare />
          )
        ) : isList ? (
          <RichListItemsView items={savedValue} />
        ) : (
          <RichMultiLanguageView value={savedValue} />
        )}
      </form>
    </Card>
  );
};

export default VacancyFieldBlock;
